import type { PublicApiKey } from '@/apilib';
import type { createAddonsPublicApi } from './publicApi';

export const AddonsApiKey: PublicApiKey<typeof createAddonsPublicApi> = {
  name: 'AddonsApi',
  public: true,
};
